import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Report } from "types";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { Loader } from "../../components/Loader";
import { CustomReportList } from "../../components/Reports/CustomReports/CustomReportList";
import { useSeller } from "../../hooks/useAccount";
import { useAutoFetchCollection } from "../../hooks/useAutoFetchCollection";
import { useSearch } from "../../hooks/useSearch";
import { useSearchAutoFocus } from "../../hooks/useSearchAutoFocus";
import { Page } from "../Page";

export const CustomReportListPage = () => {
    const seller = useSeller();
    const history = useHistory();
    const shouldAutoFocus = useSearchAutoFocus();

    const queryParams = new URLSearchParams(location.search);
    const [search, setSearch] = useState(queryParams.get("search") ?? "");

    const { data: reports, isLoading } = useAutoFetchCollection<Report>(["sellers", seller.id, "reports"]);
    const filteredReports = useSearch(reports, (report) => [report.title, report.id ?? ""], search);

    const handleClick = () => {
        history.push("/reports/customReports");
    };

    const handleSearch = (value: string) => {
        const suffix = value ? `?search=${value}` : "";
        history.push(`/reports/customReports${suffix}`);
        setSearch(value);
    };

    return (
        <Page title="Custom Reports">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="min-w-[330px] truncate border-r-0">
                        <Breadcrumb.Item>Reports</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleClick}>Custom Reports</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>

                    <HeaderToolbar.Search
                        shouldHideMenu
                        autoFocus={shouldAutoFocus}
                        defaultValue={search}
                        placeholder="Search by name or description"
                        onChange={handleSearch}
                    />
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    {isLoading ? <Loader /> : <CustomReportList reports={filteredReports} search={search} />}
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
